import React from 'react';
import PropTypes from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const SectionTitle = (props) => (
    <h5
        data-automation-id="sectionTitle"
        className={dt([
            'text-large',
            'mb-3',
            'font-open-sans-semibold',
            'text-black',
            'lg:text-xlarge',
        ])}
        {...props}
    >
        {props.children}
    </h5>
);

SectionTitle.propTypes = {
    children: PropTypes.ReactComponentLike,
};

SectionTitle.defaultProps = {
    children: '',
};

export default SectionTitle;
